<template>
  <div class="bg-gray-100 h-[calc(100vh-66px)];">
    <!-- Sticky header start from here  -->
    <header
      class="w-full bg-white h-12 px-2 flex items-center justify-between sticky top-0 z-10"
    >
      <div class="flex justify-between space-x-2">
        <div>
          <img
            class="rounded-full w-8 mt-1"
            src="https://randomuser.me/api/portraits/med/women/32.jpg"
            alt=""
          />
        </div>
        <div class="flex flex-col ml-3">
          <h6
            class="text-gray-700 text-sm"
            v-if="
              (receivedValue.name != null &&
                receivedValue.participant_2_phone_no) ||
              receivedValue.wa_phone_number
            "
          >
            {{ receivedValue.name }}
            <!-- {{receivedValue.participant_2_id}}
            {{ receivedValue.wa_phone_number }} -->
          </h6>
          <h6 v-else-if="receivedValue.participant_2_phone_no">
            {{ receivedValue.participant_2_phone_no }}
          </h6>
          <h6 v-else>
            {{ receivedValue }}
          </h6>

          <p class="text-xs text-gray-500">Last seen recently</p>
        </div>
      </div>

      <!-- mark as read button start -->
      <div class="flex">
        <button
          class="bg-white text-xs border-2 border-blue-400 text-blue-500 font-bold py-1 px-2 rounded"
        >
          <span class="mr-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="h-4 w-4 text-white bg-blue-500 rounded-full inline-block"
              style="padding: 2px"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              ></path>
            </svg>
          </span>
          Mark as Close
        </button>
        <!-- mark as read button end -->
        <div class="ml-3 relative">
          <jet-dropdown align="right">
            <template #trigger>
              <span class="inline-flex rounded-md">
                <button
                  type="button"
                  class="inline-flex items-center text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition"
                >
                  <!-- {{ $page.props.user.name }} -->

                  <img :src="'/imgs/More.png'" alt="logo" class="mt-1" />
                </button>
              </span>
            </template>

            <template #content>
              <!-- Authentication -->
              <form @submit.prevent="logout">
                <jet-dropdown-link as="button"> User </jet-dropdown-link>
                <jet-dropdown-link as="button"> Support </jet-dropdown-link>
                <jet-dropdown-link as="button"> Sign Out </jet-dropdown-link>
              </form>
            </template>
          </jet-dropdown>
        </div>
      </div>
    </header>
    <!-- Sticky header end -->
    <div
      class="flex flex-col h-[calc(100vh-164px)] overflow-y-auto cursor-pointer"
    >
      <div v-for="(message, index) in messages" :key="index" class="">
        <div v-if="message.direction === 'inbound'" class="gap-4">
          <div class="mx-2">
            <div
              class="flex justify-start gap-2"
              @contextmenu="openContextMenu($event, message)"
            >
              <!-- <div>
                <img class="rounded-full w-5" :src="message.avatar" alt="" />
              </div> -->
              <h6
                class="text-sm font-semibold text-gray-600"
                @contextmenu="openContextMenu($event, message)"
              >
                {{ message.name }}
              </h6>
              <p
                class="text-xs px-1 pt-1 text-gray-500"
                @contextmenu="openContextMenu($event, message)"
              >
                {{ message.time }}
              </p>
            </div>

            <!-- <div class="bg-white text-sm text-gray-700 p-2 rounded-sm">
            <p>{{ message.text }}</p>
          </div> -->
            <div class="flex items-end mt-1">
              <div
                class="group max-w-[600px] py-2 px-3 rounded-b-lg transition duration-500 rounded-tr-lg mr-4 bg-gray-50 dark:bg-gray-600"
              >
                <p
                  class="text-sm font-normal leading-4 tracking-[0.16px] outline-none text-black opacity-60 dark:text-white dark:opacity-70 whitespace-pre-line"
                  tabindex="0"
                  @contextmenu="openContextMenu($event, message)"
                >
                  {{ message.message_content }}
                </p>
              </div>
              <div
                v-if="message.document_url && message.type === 'image'"
                class="image-container"
                @contextmenu="openContextMenu($event, message)"
              >
                <img
                  :src="message.document_url"
                  class="fixed-size-image mt-2 rounded-sm cursor-pointer"
                  @click="openFullScreenImage(message.document_url)"
                  alt="Image"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-else class="gap-4">
          <div class="mx-2">
            <div class="flex justify-end gap-2">
              <p
                class="text-xs px-1 pt-1 text-gray-500"
                @contextmenu="openContextMenu($event, message)"
              >
                {{ message.time }}
              </p>
              <!-- <h6 class="text-sm font-semibold text-gray-600" @contextmenu="openContextMenu($event, message)"> Via
                whatsapp
              </h6> -->
              <h6
                class="text-sm font-semibold text-gray-600"
                @contextmenu="openContextMenu($event, message)"
              >
                {{ message.name }}
              </h6>
            </div>

            <div class="xs:mb-2 md:mb-3 flex justify-end">
              <div class="flex items-end">
                <div
                  v-if="message.message_content"
      class="group min-w-[120px] max-w-[600px] py-1 px-3 pr-5 rounded-b-lg transition duration-500 rounded-tl-lg ml-4 order-2 bg-indigo-100 dark:bg-indigo-100 relative"
      style="width: calc(100% + 2px);"
    >
              
    <p
        class="text-sm font-normal leading-tight tracking-[0.16px] outline-none text-black opacity-60 dark:text-white dark:opacity-70 whitespace-pre-line pb-3"
        tabindex="0"
        @contextmenu="openContextMenu($event, message)"
      >
        {{ message.message_content }}
      </p>

      <div class="read-receipt ">
        <span class="text-xs text-gray-500 mr-1">{{ getCurrentTime() }}</span>
        <svg class="h-3 w-4" viewBox="0 0 16 11" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.071 3.243L4.929 9.243L1.815 6.157" stroke="#4CAF50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          <path d="M14.071 3.243L7.929 9.243L4.815 6.157" stroke="#4CAF50" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
        </svg>
      </div>
                </div>
                <div
                  v-if="message.document_url && message.type === 'image'"
                  class="image-container"
                  @contextmenu="openContextMenu($event, message)"
                >
                  <img
                    :src="message.document_url"
                    class="fixed-size-image mt-2 rounded-sm cursor-pointer"
                    @click="openFullScreenImage(message.document_url)"
                    alt="Image"
                  />
                </div>
                <div
                  v-if="contextMenuVisible"
                  :style="{
                    top: `${contextMenuPosition.y}px`,
                    left: `${contextMenuPosition.x}px`,
                  }"
                  class="fixed bg-white shadow-md border rounded-lg p-1 z-10"
                  @click.self="closeContextMenu"
                >
                  <ul>
                    <li
                      @click="deleteMessage"
                      class="p-1 hover:bg-gray-100 cursor-pointer w-40"
                    >
                      Delete
                    </li>
                    <li
                      @click="editMessage"
                      class="p-1 hover:bg-gray-100 cursor-pointer w-40"
                    >
                      Edit
                    </li>
                    <li
                      @click="copyMessage"
                      class="p-1 hover:bg-gray-100 cursor-pointer w-40"
                    >
                      Copy
                    </li>
                    <li
                      @click="pinMessage"
                      class="p-1 hover:bg-gray-100 cursor-pointer w-40"
                    >
                      Pin
                    </li>
                    <li
                      @click="showMessageInfo"
                      class="p-1 hover:bg-gray-100 cursor-pointer w-40"
                    >
                      Info
                    </li>
                  </ul>
                </div>

                <div
                  v-if="isImageFullScreen"
                  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
                >
                  <img
                    :src="fullScreenImageUrl"
                    class="max-w-full max-h-full object-contain"
                    @click="closeFullScreenImage"
                    alt="Full Screen Image"
                  />
                  <!-- Close Button -->
                  <button
                    @click="closeFullScreenImage"
                    class="absolute top-4 right-4 text-white text-2xl"
                  >
                    ×
                  </button>
                </div>

                <div
                  class="document-preview"
                  v-if="message.document_path && message.type === 'document'"
                >
                  <a
                    :href="message.document_url"
                    target="_blank"
                    class="document-link"
                  >
                    <div class="document-thumbnail">
                      <i class="fa fa-file"></i>
                      <!-- Use an appropriate icon for documents -->
                    </div>
                    <div class="document-details">
                      <span class="document-name">{{
                        message.document_name || "Unnamed Document"
                      }}</span>
                      <!-- <span class="document-type">{{ message.document_name) }}</span> -->
                      <span class="download-icon">
                        <i class="fa fa-download"></i>
                        <!-- Download icon -->
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="image-preview-background"
      v-show="preview"
      style="display: none"
    >
      <div
        v-for="(image, index) in imagePreviews"
        :key="index"
        class="relative inline-block"
      >
        <img :src="image" class="preview-image" />

        <button
          @click="removeImage(index)"
          class="absolute top-0 right-0 bg-white text-gray-700 rounded-full p-1 shadow-md"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            class="h-4 w-4"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <div class="preview-container" v-show="docpreview" style="display: none">
      <div
        v-for="(document, index) in documentPreviews"
        v-show="docpreview"
        :key="index"
        class="relative inline-block"
        style="display: none"
      >
        <!-- PDF Preview -->
        <div v-if="document.type === 'pdf'" class="document-preview relative">
          <div class="pdf-placeholder" width="100px" height="100px">
            <img
              src="/imgs/pdf.png"
              class="w-12 h-12"
              width="100px"
              height="100px"
            />
            <span class="absolute bottom-2 text-sm text-gray-700">{{
              document.name
            }}</span>
            <button
              @click="removeDocument(index)"
              class="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Image Preview -->
        <div
          v-else-if="document.type === 'image'"
          class="image-preview relative"
        >
          <div class="img-placeholder" width="100px" height="100px">
            <img
              src="/imgs/docs.png"
              class="w-12 h-12"
              width="100px"
              height="100px"
            />
            <button
              @click="removeDocument(index)"
              class="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Unsupported File Preview -->
        <div v-else class="document-preview relative">
          <div
            class="file-placeholder bg-gray-100 w-full h-32 flex items-center justify-center"
          >
            <img src="/imgs/docs.png" alt="File Icon" class="w-12 h-12" />
            <span class="absolute bottom-2 text-sm text-gray-700">{{
              document.name
            }}</span>
            <button
              @click="removeDocument(index)"
              class="text-gray-500 hover:text-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="h-5 w-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- sms end -->

    <!-- sticky footer start -->
    <footer
      class="flex justify-between p-2 bottom-0 mx-auto max-w-6xl bg-white rounded-lg shadow"
      @submit.prevent
    >
      <div class="flex items-center space-x-2">
        <select
          id=""
          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option value="US">WhatsApp</option>
          <option value="CA">SMS</option>
          <option value="FR">Email</option>
        </select>
        <div>
          <button @click="togglePopup" class="relative">
            <img :src="'/imgs/add.png'" alt="add logo" />
          </button>
          <!-- Popup content -->
          <div
            v-show="showPopup"
            @click="closePopup"
            class="fixed inset-0 flex items-center"
            style="margin-left: 450px; margin-top: 470px"
          >
            <!-- Popup container -->
            <div class="bg-white py-2 rounded shadow-md">
              <!-- Popup content goes here -->
              <jet-dropdown-link
                as="button"
                @click="triggerDocumentInput"
                :active="route().current('tallyclinicconfigurations.index')"
                :href="'/builder/configurations'"
              >
                <div class="flex items-center">
                  <i class="fa fa-file" aria-hidden="true"></i>
                  <div class="px-3 text-xs text-gray-500">Document</div>
                </div>
              </jet-dropdown-link>
              <input
                type="file"
                ref="documentInput"
                multiple
                @change="handleDocumentChange"
                style="display: none"
              />
              <jet-dropdown-link as="button">
                <div class="flex items-center">
                  <i class="fa fa-phone" aria-hidden="true"></i>
                  <div class="px-3 text-xs text-gray-500">Contact</div>
                </div>
              </jet-dropdown-link>
              <jet-dropdown-link as="button" @click="triggerFileInput">
                <div class="flex items-center">
                  <i class="fa fa-picture-o" aria-hidden="true"></i>
                  <div class="px-3 text-xs text-gray-500">Photos & Videos</div>
                </div>
              </jet-dropdown-link>
              <input
                type="file"
                ref="fileInput"
                multiple
                accept="image/*,video/*"
                @change="handleFileChange"
                style="display: none"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="textarea-wrapper flex-grow mx-2">
        <DxTextArea
          ref="messageInput"
          :value="sms"
          @input="handleInput"
          @keydown="handleKeyDown"
          :min-height="32"
          :max-height="300"
          :auto-resize-enabled="true"
          style="padding: 2px 0; border-radius: 2px; width: 100%"
          :placeholder="
            receivedValue?.name
              ? `Message ${receivedValue.name}...`
              : `Message ${receivedValue?.participant_2_phone_no || ''}...`
          "
        />
      </div>
      <button>
        <img :src="'/imgs/send1.png'" alt="logo" @click.prevent="sendMessage" />
      </button>
    </footer>
  </div>
</template>
<script>
import NavBar from "@/Layouts/NavBar.vue";
import JetResponsiveNavLink from "@/Jetstream/ResponsiveNavLink.vue";
import JetSideLink from "@/Jetstream/SideLink.vue";
import DxTextArea from "devextreme-vue/text-area";
import JetDropdown from "@/Jetstream/Dropdown.vue";
import JetDropdownLink from "@/Jetstream/DropdownLink.vue";
import axios from "axios";
import { ref } from "vue";
import { defineEmits } from "vue";

export default {
  props: {
    selectedId: String,
    selectedType: String,
    receivedValue: {
      type: Object,
      required: false, // or true if you expect it to always be passed
      default: () => ({}),
    },
    receivedValue: {
      type: String,
      required: false,
      default: () => ({}),
    },
  },

  components: {
    NavBar,
    JetResponsiveNavLink,
    JetSideLink,
    DxTextArea,
    JetDropdown,
    JetDropdownLink,
  },
  data() {
    return {
      contextMenuVisible: ref(false),
      contextMenuPosition: ref({ x: 0, y: 0 }),
      selectedMessage: ref(null),
      isImageFullScreen: false,
      fullScreenImageUrl: "",
      filename: "",
      selectedUnread: ref(null),
      messages: [],
      message: "",
      docpreview: false,
      preview: false,
      showPopup: false,
      userShowOptions: true,
      files: "", // Defined here
      imagePreviews: [], // Array to store image URLs
      selectedFiles: [],
      selectedDocument: [],
      documentPreviews: [], // Define this if you want to use image preview
      sms: "",
      chatData: [
        {
          chat_id: "1",
          sender_id: "",
          receiver_id: "",
          chats: [
            {
              name: "Tarun Sir",
              avatar: "https://randomuser.me/api/portraits/med/men/75.jpg",
              time: "11:30 PM",
              text: "hello!! I am Tarun",
              communicator_type: "receiver",
            },
            {
              name: "Saurabh Sir",
              time: "11:40 PM",
              text: "Kon Tarun??",
              communicator_type: "sender",
            },
            {
              name: "Tarun Sir",
              avatar: "https://randomuser.me/api/portraits/med/men/75.jpg",
              time: "11:30 PM",
              text: "From Sparsh...Components Basics ​. Components allow us to split the UI into independent and reusable pieces, and think about each piece in isolation",
              communicator_type: "receiver",
            },
            // Add more messages as needed
            {
              name: "Saurabh Sir",
              time: "11:40 PM",
              text: "Hii!!",
              communicator_type: "sender",
            },
            {
              name: "Tarun Sir",
              avatar: "https://randomuser.me/api/portraits/med/men/75.jpg",
              time: "11:30 PM",
              text: "hello!! I am Tarun",
              communicator_type: "receiver",
            },
            {
              name: "Saurabh Sir",
              time: "11:40 PM",
              text: "Kon Tarun??  Components Basics ​. Components allow us to split the UI into",
              communicator_type: "sender",
            },
            {
              name: "Tarun Sir",
              avatar: "https://randomuser.me/api/portraits/med/men/75.jpg",
              time: "11:30 PM",
              text: "From Sparsh",
              communicator_type: "receiver",
            },
            // Add more messages as needed
            {
              name: "Saurabh Sir",
              time: "11:40 PM",
              text: "Hii!!",
              communicator_type: "sender",
            },
          ],
        },
      ],
    };
  },

  methods: {
    //
    handleInput(newValue) {
      // For DevExtreme TextArea, we need to extract the text value
      if (newValue && newValue.event && newValue.event.target) {
        // Extract the actual text value from the input element
        this.sms = newValue.event.target.value || "";
      } else if (typeof newValue === "string") {
        // If it's already a string, use it directly
        this.sms = newValue;
      } else {
        // Fallback to empty string for other cases
        this.sms = "";
      }
    },
    openContextMenu(event, message) {
      this.contextMenuPosition = { x: event.clientX, y: event.clientY };
      this.selectedMessage = message;
      this.contextMenuVisible = true;
      event.preventDefault();
    },

    closeContextMenu() {
      contextMenuVisible.value = false;
    },

    deleteMessage() {
      console.log("Delete message:", selectedMessage.value);
      closeContextMenu();
    },

    editMessage() {
      console.log("Edit message:", selectedMessage.value);
      closeContextMenu();
    },

    copyMessage() {
      console.log("Copy message:", selectedMessage.value);
      closeContextMenu();
    },

    pinMessage() {
      console.log("Pin message:", selectedMessage.value);
      closeContextMenu();
    },

    showMessageInfo() {
      console.log("Message info:", selectedMessage.value);
      closeContextMenu();
    },

    openFullScreenImage(imageUrl) {
      this.fullScreenImageUrl = imageUrl;
      this.isImageFullScreen = true;
    },
    closeFullScreenImage() {
      this.isImageFullScreen = false;
      this.fullScreenImageUrl = "";
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    closePopup() {
      this.showPopup = false;
    },

    userOptions() {
      this.userShowOptions = !this.userShowOptions;
    },

    // sendMessage() {
    //   console.log("Sending message:", this.sms ='' );
    // },
    handleKeyDown(e) {
      if (e.event.key === "Enter" && !e.event.shiftKey) {
        e.event.preventDefault();
        this.sendMessage();
      }
    },

    triggerDocumentInput() {
      this.$refs.documentInput.click();
      this.preview = false;
    },

    handleDocumentChange(event) {
      const files = Array.from(event.target.files);
      this.documentPreviews = []; // Clear previous previews

      files.forEach((file) => {
        const reader = new FileReader();
        this.docpreview = true;

        reader.onload = (e) => {
          let type;
          if (file.type === "application/pdf") {
            type = "pdf";
          } else if (file.type.startsWith("image/")) {
            type = "image";
          } else {
            type = "unsupported";
          }
          this.docpreview = true;
          this.documentPreviews.push({
            url: e.target.result,
            type: type,
          });
        };

        if (file.type === "application/pdf" || file.type.startsWith("image/")) {
          reader.readAsDataURL(file);
          this.docpreview = true;
        }
      });
      this.selectedDocument = [...this.selectedDocument, ...files];
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
      this.docpreview = false;
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);
      if (this.selectedFiles.length + files.length > 20) {
        alert("You can only upload up to 20 files.");
        return;
      }
      if (files.length > 20) {
        alert("You can only select up to 10 images or videos.");
        return;
      }
      this.preview = true;
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result); // Add image URL to preview array
        };
        reader.readAsDataURL(file);
      });
      this.selectedFiles = [...this.selectedFiles, ...files]; // Add new files to the selected files array
    },
    removeImage(index) {
      this.imagePreviews.splice(index, 1); // Remove image from preview array
      this.selectedFiles.splice(index, 1); // Remove corresponding file from selected files
    },
    removeDocument(index) {
      this.documentPreviews.splice(index, 1);
      this.selectedDocument.splice(index, 1);
    },
    sendImage() {
      if (this.imagePreviews) {
        this.sendMessage(); // Call sendMessage to handle image sending
        this.closePreview();
        this.preview = false;
        this.docpreview = false;
      }
    },

    sendDocument() {
      if (this.documentPreviews) {
        this.sendMessage(); // Call sendMessage to handle Dcoument sending
        this.closePreview();
        this.preview = false;
        this.docpreview = false;
      }
    },

    getDocumentType(fileName) {
      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "PDF Document";
        case "doc":
        case "docx":
          return "Word Document";
        case "xls":
        case "xlsx":
          return "Excel Spreadsheet";
        default:
          return "File";
      }
    },
    closePreview() {
      this.imagePreview = "";
      this.documentPreviews = "";
      this.docpreview = false;
      this.preview = false;
    },

    async uploadFiles() {
      const formData = new FormData();
      this.selectedFiles.forEach((file) => {
        formData.append("files[]", file);
        formData.append(
          "phone_no",
          this.receivedValue.participant_2_phone_no ||
            this.receivedValue.wa_phone_number ||
            this.receivedValue
        );
        formData.append("name", this.receivedValue.name);
      });
      try {
        const response = await axios.post(
          "/all/conversation/deliverImage",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return response.data; // Return uploaded file info
      } catch (error) {
        console.error("Error uploading files:", error);
        return {}; // Return an empty object in case of error
      }
    },

    async fetchMessages() {
      try {
        const phone_no =
          this.receivedValue.participant_2_phone_no ||
          this.receivedValue.wa_phone_number ||
          this.receivedValue;
        const response = await axios.get(`/all/conversation/fetchmsg`, {
          params: {
            phone_no: phone_no,
          },
        });
        this.messages = response.data;
        console.log(this.messages);
      } catch (error) {
        console.error("Error fetching messages:", error);
      }
    },

    async uploadDocument() {
      const formData = new FormData();
      this.selectedDocument.forEach((file) => {
        formData.append("files[]", file);
        formData.append(
          "phone_no",
          this.receivedValue.participant_2_phone_no ||
            this.receivedValue.wa_phone_number ||
            this.receivedValue
        );
        formData.append("name", this.receivedValue.name);
      });
      try {
        const response = await axios.post(
          "/all/conversation/deliverDocument",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        return response.data; // Return uploaded file info
      } catch (error) {
        console.error("Error uploading files:", error);
        return {}; // Return an empty object in case of error
      }
    },

    emit: defineEmits(["messageSent"]),

    // Fix for the handleKeyDown method
    handleKeyDown(e) {
      // If Enter is pressed without Shift, send the message
      if (e.event.key === "Enter" && !e.event.shiftKey) {
        e.event.preventDefault(); // Prevent default Enter behavior (new line)
        this.sendMessage();
      }
    },

    // Corrected sendMessage method
    async sendMessage() {
      let messageToSend = "";

      if (this.$refs.messageInput && this.$refs.messageInput.instance) {
        // Get value directly from the DevExtreme instance
        messageToSend = this.$refs.messageInput.instance.option("value") || "";
      } else {
        // Fallback to the component data property
        messageToSend = this.sms;
      }

      if (
        messageToSend.trim() ||
        this.selectedFiles.length > 0 ||
        this.selectedDocument.length > 0
      ) {
        const time = new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });

        let imageUrls = [];
        let DocumentUrls = [];

        if (this.selectedFiles.length > 0) {
          try {
            const uploadResponse = await this.uploadFiles();
            if (uploadResponse && uploadResponse.urls) {
              imageUrls = uploadResponse.urls;
            } else {
              console.error("Error uploading files:", uploadResponse);
            }
          } catch (error) {
            console.error("Error uploading files:", error);
          }
        }

        if (this.selectedDocument.length > 0) {
          try {
            const uploadResponse = await this.uploadDocument();
            if (uploadResponse && uploadResponse.urls) {
              DocumentUrls = uploadResponse.urls;
            } else {
              console.error("Error uploading documents:", uploadResponse);
            }
          } catch (error) {
            console.error("Error uploading documents:", error);
          }
        }

        if (imageUrls.length > 0) {
          try {
            await axios.post("/all/conversation/deliverImage", {
              type: "Image",
              image_urls: imageUrls,
              phone_no:
                this.receivedValue.participant_2_phone_no ||
                this.receivedValue.wa_phone_number ||
                this.receivedValue,
              name: this.receivedValue.name,
            });
          } catch (error) {
            console.error("Error delivering image:", error);
          }
        }

        if (DocumentUrls.length > 0) {
          try {
            await axios.post("/all/conversation/deliverDocument", {
              type: "Document",
              document_urls: DocumentUrls,
              phone_no:
                this.receivedValue.participant_2_phone_no ||
                this.receivedValue.wa_phone_number ||
                this.receivedValue,
              name: this.receivedValue.name,
            });
          } catch (error) {
            console.error("Error delivering document:", error);
          }
        }

        // This else if was causing text messages to not be sent when files were also selected
        // Changed to just if to handle text regardless of file uploads
        if (messageToSend.trim()) {
          try {
            await axios.post("/all/conversation/deliverText", {
              message: messageToSend,
              phone_no:
                this.receivedValue.participant_2_phone_no ||
                this.receivedValue.wa_phone_number ||
                this.receivedValue,
              name: this.receivedValue.name,
            });
            this.$emit("messageSent");
            this.sms = "";
          } catch (error) {
            console.error("Error delivering text:", error);
          }
        }

        // Clear fields after sending
        // Clear text input
        this.selectedFiles = []; // Clear selected files
        this.imagePreviews = [];
        this.selectedDocument = [];
        this.documentPreviews = [];
        this.preview = false;
        this.docpreview = false;
        this.sms = "";
        this.lastSmsValue = "";
        if (this.$refs.messageInput && this.$refs.messageInput.instance) {
          this.$refs.messageInput.instance.option("value", "");
        }
      } else {
        console.log("Nothing to send - empty message and no files");
      }
      this.fetchMessages();
    },
    getCurrentTime() {
      const now = new Date();
      let hours = now.getHours();
      const minutes = now.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      
      const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
      return `${hours}:${formattedMinutes} ${ampm}`;
    },
  },

  mounted() {
    console.log("WHTASAPP SCREEN whtstitle = ", this.receivedValue);

    // Add global event listener for Enter key
    document.addEventListener("keydown", (e) => {
      if (
        e.key === "Enter" &&
        !e.shiftKey &&
        document.activeElement.closest(".textarea-wrapper")
      ) {
        console.log("Global enter handler triggered");
        e.preventDefault();
        e.stopPropagation();
        this.sendMessage();
      }
    });

    // Fetch initial messages
    this.fetchMessages();
  },
  beforeUnmount() {
    // Clean up event listener when component is destroyed
    document.removeEventListener("keydown", this.handleGlobalKeydown);
  },
};
</script>

<style>
.remove-button svg {
  width: 5px;
  /* Adjust icon size */
  height: 5px;
  color: red;
  /* Icon color */
}

.remove-button {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
  /* Semi-transparent background for visibility */
  border: none;
  border-radius: 50%;

  cursor: pointer;
  z-index: 10;
}

.preview-image,
.document-Previews {
  width: 70px;
  height: 70px;
  object-fit: cover;
  /* Ensures images are properly scaled */
  object-position: right;
  border-radius: 2px 2px 2px 2px;
  /* transition: transform 0.3s ease; Smooth scaling effect */
  padding-right: 10px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.preview-image:hover,
.documentPreviews:hover {
  transform: scale(1.05);
  /* Slight zoom on hover */
}

.send-button,
.close-button {
  margin: 5px;
}

p {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.chatbox-input {
  /* position:relative; */
  /* width: 100%;
  height: 60px; */
  background: #e6e6e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chatbox i {
  cursor: pointer;
  font-size: 1.4em;
  color: #515855;
}

.chatbox .ic {
  cursor: pointer;
  font-size: 1em;
}

.chatbox i:nth-child(1) {
  margin: 15px;
}

.chatbox i:last-child {
  margin-right: 20px;
}

.chatbox input {
  position: relative;
  width: 90%;
  margin: 0 20px;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 1em;
  border: none;
  outline: none;

  /* background-color: red; */
}

/*header {
  z-index: 100;
}*/

.mt-5 {
  margin-top: 4rem !important;
}

h6 {
  margin-bottom: 0.1rem;
}

.text-sm {
  margin-bottom: 0.1em;
}

.inset-0 {
  top: 400px;
  right: 480px;
  bottom: 0px;
  left: 0px;
}

.image-preview-background,
.preview-container {
  width: 885px;
  height: 70px;
  background-color: white;
  position: fixed;
  margin-top: -70px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
  top: 0;
  right: 0;
}

.bg-white {
  background-color: white;
}

.text-gray-700 {
  color: #4a5568;
}

.rounded-full {
  border-radius: 50%;
}

.p-1 {
  padding: 0.25rem;
}

.shadow-md {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* footer css start */
footer {
  /* Remove `fixed` for non-sticky footer */
  background-color: #333;
  color: white;
  text-align: center;
  padding: 10px;
}

.image-container {
  position: relative;
}

.fixed-size-image {
  width: 200px;
  /* Fixed width */
  height: 200px;
  /* Fixed height */
  object-fit: cover;
  /* Maintain aspect ratio, cover the area */
}

.document-preview {
  display: flex;
  align-items: center;
  margin: 10px 0;
  padding: 10px;
  background-color: #ffffff;
}

.document-preview:hover {
  background-color: #f0f0f0;
  /* Hover effect */
}

.document-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #000;
  /* Text color */
  width: 100%;
  /* Make link fill the container */
}

.document-thumbnail {
  width: 40px;
  /* Width for the thumbnail */
  height: 40px;
  /* Height for the thumbnail */
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  /* Background for the thumbnail */
  border-radius: 4px;
  /* Rounded corners */
  margin-right: 10px;
  /* Space between thumbnail and details */
}

.document-details {
  flex: 1;
  /* Allows details to take available space */
}

.document-name {
  font-weight: bold;
  /* Bold document name */
  display: block;
  /* Block display */
}

.document-type {
  font-size: 0.8em;
  /* Smaller font size for type */
  color: #888;
  /* Color for type */
  display: block;
  /* Block display */
}

.download-icon {
  margin-left: 10px;
  /* Space before the download icon */
  font-size: 0.9em;
  /* Size for the download icon */
  color: #007bff;
  /* Color for the download icon */
}

.fixed.inset-0 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.fixed-size-image {
  width: 100px;
  /* Adjust size as needed */
  height: 100px;
}

.messages-container {
  scrollbar-width: thin;
  scrollbar-color: rgba(156, 163, 175, 0.5) transparent;

  scrollbar-width: thin;
  scrollbar-color: rgba(156, 163, 175, 0.5) transparent;
}
.double-ticks {
  position: absolute;
  bottom: 4px;
  right: 8px;
  display: flex;
}

.double-ticks svg {
  width: 16px;
  height: 16px;
}
  .read-receipt {
    position: absolute;
    bottom: 2px;
    right: 6px;
    display: flex;
    align-items: center;
  }
  .double-tick {
    height: 14px;
    width: 14px;
  }
/* footer css end */
</style>